module.exports = __webpack_public_path__ + "img/pass_card_3.0b1498ff.png";